import * as React from "react";
import type { SVGProps } from "react";
const SvgItalic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 5a1 1 0 1 0 0-2zm-9-2a1 1 0 0 0 0 2zm4 18a1 1 0 1 0 0-2zm-9-2a1 1 0 1 0 0 2zM15.936 4.351a1 1 0 0 0-1.872-.702zM8.064 19.65a1 1 0 1 0 1.872.702zM19 3h-9v2h9zm-5 16H5v2h9zm.064-15.351-6 16 1.872.702 6-16z"
    />
  </svg>
);
export default SvgItalic;
